import React from "react";
import {Trans} from "react-i18next";
import FormField from "./FormField";

class InputField extends FormField {
    render() {
        const {
            input,
            placeholder,
            type,
            label,
            meta: {touched, error, warning, invalid},
            disabled,
            autoFocus,
            showErrorBlock = true
        } = this.props;

        return (
            <span className={`form-filed-container ${touched && invalid ? 'has-error' : ''}`}>
                {label && (<label>{label}</label>)}
                <input
                    {...input}
                    type={type}
                    placeholder={placeholder}
                    className={this.getClassName()}
                    disabled={disabled}
                    autoFocus={autoFocus}
                />
                {showErrorBlock && touched && (
                    (error && <div className="text-danger scroll-to-error"><Trans>{error}</Trans></div>) ||
                    (warning && <div className="text-warning"><Trans>{warning}</Trans></div>)
                )}
            </span>
        )
    }
}

export default InputField;